import { UpdatePaymentAccountsListApi } from "@/features/accounts/payment/scraping/services/update-accounts-list-api";
import { UpdatePaymentAccountsListRequestModel } from "@/features/accounts/payment/scraping/services/update-accounts-list-model";

/// MoneyLook 口座更新処理(スクレイピング)
export class UpdatePaymentAccountsListService {
  private updatePaymentAccountsListApi = new UpdatePaymentAccountsListApi();

  /**
   * MoneyLook 口座更新API(スクレイピング)実行
   */
  public async updatePaymentAccountsList(param: UpdatePaymentAccountsListRequestModel) {
    return await this.updatePaymentAccountsListApi.updatePaymentAccountsList(param);
  }
}